/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { EditorIframeComponent } from '../editor-iframe/editor-iframe.component';

import { WorkspaceSocketService } from '@workspaces/utils/workspace-socket.service';
export const PostMessageIds = [
  // "Host_PostmessageReady",
  'Get_Views',
  'Get_Export_Formats',
  'Get_User_State',
  'Action_RemoveView',
  'Reset_Access_Token',
  'Host_VersionRestore',
  'Action_Save',
  'Action_SaveAs',
  'Action_InsertGraphic',
  'Action_InsertLink',
  'Insert_Button',
  'Insert_ContextualButton',
  'Hide_Button',
  'Show_Button',
  'Remove_Button',
  'Hide_Command',
  'Show_Command',
  'Send_UNO_Command',
  'CallPythonScript',
  'Action_Mention'
] as const;

@Component({
  selector: 'app-test-opener',
  templateUrl: './test-opener.component.html',
  styleUrls: ['./test-opener.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatRadioButton,
    MatRadioGroup,
    MatLabel,
    MatFormField,
    MatButton,
    MatInput,
    EditorIframeComponent
  ]
})
export class TestOpenerComponent implements AfterViewInit {
  collaboraIframeUrl = '';
  workspaceId = '';
  currentMessage = '';
  currentCommand: (typeof PostMessageIds)[number] = 'Send_UNO_Command';
  readonly postMessageIds = PostMessageIds;

  @ViewChild('editor') editor!: EditorIframeComponent;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly workspaceSocketService: WorkspaceSocketService
  ) {}
  ngAfterViewInit() {
    window.addEventListener('message', event => {
      this.getOriginMessage(event);
    });
    this.initializeStandaloneWindow();
  }

  initializeStandaloneWindow() {
    const sidebar = this.document.getElementsByClassName('sidebar')[0] as HTMLDivElement;
    const leftNav = this.document.getElementsByClassName('left-content')[0] as HTMLDivElement;
    const rightNav = this.document.getElementsByClassName('right-content')[0] as HTMLDivElement;
    const matSideContent = this.document.getElementsByTagName('mat-sidenav-content')[0] as HTMLDivElement;
    if (sidebar) {
      sidebar.remove();
    }
    if (leftNav) {
      const openerIcon = leftNav.getElementsByTagName('mat-icon')[0];
      openerIcon?.remove();
    }
    if (rightNav) {
      rightNav.remove();
    }
    if (matSideContent) {
      matSideContent.style.marginLeft = '0';
      this.document.documentElement.style.setProperty('--sidebar-width', '0');
    }

    window.opener.postMessage(
      {
        type: 'CHILD_READY'
      },
      window.location.origin // The parent is on the same origin
    );
  }

  getOriginMessage(event: MessageEvent<any>) {
    if (event.origin !== window.location.origin) {
      return;
    }
    const receivedData = event.data;

    if (receivedData && receivedData.type === 'SEND_IFRAME_URL') {
      this.collaboraIframeUrl = receivedData.src.collaboraIframeUrl;
      this.workspaceId = receivedData.src.workspaceId;
      this.initWebsocket();
    }
  }
  private initWebsocket() {
    this.workspaceSocketService.setCurrentlyOpenedWorkspace(this.workspaceId);

    if (this.workspaceId) {
      this.workspaceSocketService.subscribeToWorkspace(this.workspaceId);
    }
  }

  sendCollaboraPostMessage() {
    this.editor.sendCollaboraPostMessage(this.currentCommand, this.currentMessage);
  }
}
